<template>
  <div class="content-wrapper content-wrapper--align-start">
    <h1>Chatterbox Overview</h1>
    <div>
      <div class="tabs">
        <template v-for="site in siteList">
          <div
            @click="
              siteFilter = site.id
              if (site.market === 'all') {
                marketFilter = ''
              } else {
                marketFilter = site.market
              }
              getChatterboxTasks()
            "
            v-bind:key="site.id"
            :class="['tab', { 'tab--active': siteFilter == site.id }]"
          >
            <img :src="require(`@/assets/sites/${site.id}.svg`)" />
            <span>{{ site.name }}</span>
          </div>
        </template>
      </div>
      <div class="card">
        <div class="table-options">
          <div class="select-container select-container--no-label">
            <select @change="getChatterboxTasks()" v-model="flairFilter">
              <option value="">All Flairs</option>
              <option v-for="flair in flairList" v-bind:key="flair.id" :value="flair.id">{{ flair.name }}</option>
            </select>
            <!-- prettier-ignore -->
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
          </div>
          <div class="select-container select-container--no-label" v-if="siteFilter == 'casinobernie'">
            <select @change="getChatterboxTasks()" v-model="marketFilter">
              <option value="">All Markets</option>
              <option v-for="market in marketList" :key="market.id" :value="market.id">{{ market.name }}</option>
            </select>
            <!-- prettier-ignore -->
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999"></path></svg>
          </div>
        </div>
        <div class="table-container">
          <div class="table">
            <div class="table__headers">
              <div class="table__header">Flair</div>
              <div class="table__header">Market</div>
              <div class="table__header">Status</div>
            </div>
            <template>
              <div v-for="market in selectedMarketList" v-bind:key="market.id">
                <div v-for="flair in selectedFlairList" v-bind:key="flair.id">
                  <div class="table__row-container" v-if="getTask(market.id, flair.id).length > 0">
                    <div class="table__row">
                      <div class="table__cell">{{ getFlairName(getTask(market.id, flair.id)[0].flair) }}</div>
                      <div class="table__cell">{{ getMarketName(getTask(market.id, flair.id)[0].marketId) }}</div>
                      <div class="table__cell" :class="{ red: isOld(getTask(market.id, flair.id)[0].createdAt) }">
                        {{ getStatus(getTask(market.id, flair.id)[0]) }} ({{ getTask(market.id, flair.id)[0].status }})
                      </div>
                    </div>
                    <div class="table__edit">
                      <!-- prettier-ignore -->
                      <svg ref="options" class="options" v-click-outside="onClickOutside" @click="toggleEdit($event)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none" /><path fill="#999" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" /></svg>
                      <div class="edit">
                        <router-link class="edit__item" :to="{ name: 'taskId', params: { id: getTask(market.id, flair.id)[0].id } }">View task</router-link>
                        <router-link class="edit__item" :to="{ name: 'new', params: { type: 'chatterbox', flair: flair.id, market: market.id, site: siteFilter } }">Create New Task</router-link>
                      </div>
                    </div>
                  </div>
                  <div class="table__row-container" v-if="getTask(market.id, flair.id).length == 0">
                    <div class="table__row table__row--missing">
                      <div class="table__cell">{{ getFlairName(flair.id) }}</div>
                      <div class="table__cell">{{ getMarketName(market.id) }}</div>
                      <div class="table__cell">Missing</div>
                    </div>
                    <div class="table__edit">
                      <!-- prettier-ignore -->
                      <svg ref="options" class="options" v-click-outside="onClickOutside" @click="toggleEdit($event)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px"><path d="M0 0h24v24H0z" fill="none" /><path fill="#999" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" /></svg>
                      <div class="edit">
                        <router-link class="edit__item" :to="{ name: 'new', params: { type: 'chatterbox', flair: flair.id, market: market.id, site: siteFilter } }">New Task</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import vClickOutside from 'v-click-outside'
import moment from 'moment'

export default {
  name: 'chatterbox-overview',
  data() {
    return {
      siteFilter: 'kasinohai',
      marketFilter: 'fi',
      flairFilter: '',
    }
  },
  computed: {
    ...mapGetters(['user', 'siteList', 'flairList', 'marketList']),
    selectedMarketList() {
      if (this.marketFilter === '' || this.marketFilter === 'all') {
        return this.marketList
      }
      return this.marketList.filter(market => {
        return market.id === this.marketFilter
      })
    },
    selectedFlairList() {
      if (this.flairFilter === '') {
        return this.flairList
      }
      return this.flairList.filter(flair => {
        return flair.id === this.flairFilter
      })
    },
    filteredTasks() {
      return this.$store.getters.tasks
    },
  },
  methods: {
    onClickOutside(event) {
      this.$refs.options.forEach(option => {
        if (!event.target.classList.contains('options')) {
          if (option.classList.contains('open')) {
            option.classList.remove('open')
          }
        }
      })
    },
    getTask(market, flair) {
      return this.filteredTasks.filter(task => {
        return task.marketId == market && task.flair == flair && task.content.siteIds.includes(this.siteFilter)
      })
    },
    getMarketName(marketId) {
      return this.$store.getters.marketName(marketId)
    },
    getFlairName(marketId) {
      return this.$store.getters.flairName(marketId)
    },
    getStatus(task) {
      return this.isInProgress(task.status) ? 'In Progress' : moment(task.createdAt).fromNow()
    },
    isInProgress(status) {
      return status == 'exported'
    },
    isOld(createdAt) {
      const todayDate = moment()
      const createdAtDate = moment(createdAt)

      return todayDate.diff(createdAtDate, 'days') >= 90 ? true : false
    },
    toggleEdit($event) {
      $event.target.classList.toggle('open')
    },
    getChatterboxTasks() {
      var params = {
        endpoint: 'getchatterboxbyfilters',
        type: 'chatterbox',
      }
      if (this.siteFilter) {
        params['site'] = this.siteFilter
      }
      if (this.flairFilter) {
        params['flair'] = this.flairFilter
      }
      if (this.marketFilter) {
        params['marketid'] = this.marketFilter
      }
      this.$store
        .dispatch('fetchTasks', {
          params,
          userId: this.user.data.uid,
        })
        .then((this.isFetching = false))
    },
  },
  mounted: function() {
    this.getChatterboxTasks()
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';
@import '@/assets/shared-styles/select.scss';
@import '@/assets/shared-styles/table.scss';

.tabs {
  display: flex;
}

.tab {
  display: flex;
  align-items: center;
  background: #f8f8f8;
  cursor: pointer;
  padding: 0.75rem 1rem;
  border-radius: 0.25rem 0.25rem 0 0;
  margin-right: 0.325rem;
  color: #a3a6b4;
  font-size: 0.9375rem;
}

.tab:hover {
  background: white;
}

.tab img {
  width: 1.5rem;
  min-height: 1.5rem;
  margin-right: 0.25rem;
}

.tab--active {
  background: #fff;
  color: var(--color-cta);
}

.card {
  background-color: #fff;
  padding: 2rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  height: fit-content;
  box-sizing: border-box;
}
.table-options .select-container {
  margin-right: 1rem;
  margin-left: 0rem;
  min-width: 140px;
}
.select-container select {
  background: #fff;
  box-shadow: none;
  border: 1px solid #ebebf2;
}
.table-container {
  margin-top: 1.5rem;
}
.table__headers,
.table__row {
  grid-column: auto;
  grid-template-columns: 200px 200px 1fr;
}
.table__headers {
  padding-right: 30px;
}
.table__row {
  cursor: auto;
  padding-right: 0;
}
.table__row--missing {
  color: #4d4f5c70;
}
.table__cell,
.table__header {
  padding: 0.7rem 0.5rem;
}
.button.button--thin {
  padding: 0.25rem 1.25rem;
}
.button:disabled {
  opacity: 0.2;
  cursor: auto;
}
.button:hover {
  transform: none;
}

.edit {
  position: absolute;
  top: 2.5rem;
  right: 0;
  display: none;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.edit__item {
  padding: 0.5rem 1rem;
  color: #4d4f5c;
  font-size: 0.875rem;
  text-decoration: none;
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
}

.edit__item:hover {
  background-color: #fafafc;
}

.open + .edit {
  display: flex;
  flex-direction: column;
  z-index: 2;
}

.options {
  transform: none !important;
  color: '#A3A6B4';
  align-self: center;
}

.options > path:nth-child(2) {
  pointer-events: none;
}
.table__row-container {
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
}

.table__row-container:hover {
  background-color: #fafafc;
}
.table__row:hover .options > path:first-of-type {
  fill: none;
}
.red {
  color: var(--color-danger);
}

.table__edit {
  position: relative;
  display: flex;
  justify-content: center;
}

.table__edit > svg {
  cursor: pointer;
}

.table__edit svg:hover,
.table__row--available:hover .table__cell,
.table__row--available:hover .table__cell svg {
  color: var(--color-cta);
  fill: var(--color-cta);
}
</style>
